/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_American_Studies22Inputs */

const en__field__enum_additionalstudyinterests_study_american_studies22 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_American_Studies22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Studies`)
};

const de__field__enum_additionalstudyinterests_study_american_studies22 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_American_Studies22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Studies`)
};

/**
* | output |
* | --- |
* | "American Studies" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_American_Studies22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_american_studies22 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_American_Studies22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_American_Studies22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_american_studies22(inputs)
	return de__field__enum_additionalstudyinterests_study_american_studies22(inputs)
});
export { _field__enum_additionalstudyinterests_study_american_studies22 as "_field__enum_additionalStudyInterests_STUDY_AMERICAN_STUDIES" }